import React, { useState, useCallback } from 'react';
import { TextField } from 'react-md/lib/TextFields';
import { isEnterKeyPress } from 'Util/Helpers/Input';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsSuccess, selectIsLoading } from 'State/Redux/AsyncRedux';
import { toast } from 'react-toastify';
import ExpansionPanel, { ExpansionList } from 'react-md/lib/ExpansionPanels';
import LoadingButton from 'Components/Common/LoadingButton';
import {
   selectSystemParameter,
   SystemParametersActions,
   SystemParametersTypes,
} from 'State/Redux/SystemParametersRedux';
import {
   DefaultSystemParametersModel,
   validateSystemParameters,
} from 'Models/SystemParameters/Data/SystemParameters';

const AddSystemParameter = (): JSX.Element => {
   const systemParameter = useSelector(selectSystemParameter);
   const isLoading = useSelector(
      selectIsLoading([SystemParametersTypes.ADD_SYSTEM_PARAMETERS_REQUEST])
   );
   const isSuccess = useSelector(
      selectIsSuccess([SystemParametersTypes.ADD_SYSTEM_PARAMETERS_REQUEST])
   );

   const dispatch = useDispatch();

   const [systemParameterModel, setSystemParameterModel] = useState(
      DefaultSystemParametersModel
   );

   const [addClicked, setAddClicked] = useState(false);

   const onAdd = useCallback((): void => {
      dispatch(
         SystemParametersActions.addSystemParametersRequest({
            ...systemParameterModel,
         })
      );
      setAddClicked(true);
   }, [dispatch, systemParameterModel]);

   if (addClicked && isSuccess && systemParameter !== null) {
      toast.success(
         `New system parameter "${systemParameter.parameterCode}" created!`
      );
      setAddClicked(false);
      setSystemParameterModel(DefaultSystemParametersModel);
   }
   const isValidForm = Object.values(
      validateSystemParameters(systemParameterModel)
   ).every((v): boolean => !!v);

   return (
      <ExpansionList className="md-cell md-cell--12">
         <ExpansionPanel
            label="Add"
            footer={null}
            expanded
            expanderIcon={<></>}
            onExpandToggle={(): void => {}}
         >
            <div className="md-grid md-cell--12">
               <div className="md-cell md-cell--6">
                  <TextField
                     floating
                     id="floating-center-title"
                     label="Code"
                     lineDirection="center"
                     className="md-cell md-cell--12"
                     placeholder="Code"
                     value={systemParameterModel.parameterCode}
                     maxLength={4}
                     onChange={(val): void => {
                        const newModel = {
                           ...systemParameterModel,
                           parameterCode: val.toString(),
                        };
                        setSystemParameterModel(newModel);
                     }}
                     required
                  />
               </div>
               <div className="md-cell md-cell--6">
                  <TextField
                     floating
                     id="floating-center-title"
                     label="Description"
                     lineDirection="center"
                     className="md-cell md-cell--12"
                     placeholder="Description"
                     value={systemParameterModel.description}
                     onChange={(val): void => {
                        const newModel = {
                           ...systemParameterModel,
                           description: val.toString(),
                        };
                        setSystemParameterModel(newModel);
                     }}
                     required
                  />
               </div>

               <div className="md-cell md-cell--6">
                  <TextField
                     floating
                     id="floating-center-title"
                     label="Value"
                     lineDirection="center"
                     className="md-cell md-cell--12"
                     placeholder="Value"
                     value={systemParameterModel.value}
                     onChange={(val): void => {
                        const newModel = {
                           ...systemParameterModel,
                           value: val.toString(),
                        };
                        setSystemParameterModel(newModel);
                     }}
                     required
                  />
               </div>

               <div className="md-cell md-cell--12">
                  <LoadingButton
                     flat
                     primary
                     swapTheming
                     isLoading={isLoading}
                     className="md-cell md-cell--2 md-cell--10-offset add-matter-button"
                     disabled={!isValidForm}
                     onKeyUp={(keyPress): void => {
                        if (!isEnterKeyPress(keyPress)) return;
                        onAdd();
                     }}
                     onClick={(): void => {
                        onAdd();
                     }}
                  >
                     Add
                  </LoadingButton>
               </div>
            </div>
         </ExpansionPanel>
      </ExpansionList>
   );
};

export default AddSystemParameter;
